<template>
  <div class="lwgl" v-on:scroll="handleScroll">
    <div style="text-align: left; line-height: 25px">
      <p style="font-weight: bold">Python中的赋值(复制)、浅拷贝与深拷贝</p>
      <p><i class="el-icon-s-opportunity"></i> 变量：是一个系统表的元素，拥有指向对象的连接空间</p>
      <p><i class="el-icon-s-opportunity"></i>对象：被分配的一块内存，存储其所代表的值</p>
      <p><i class="el-icon-s-opportunity"></i>引用：是自动形成的从变量到对象的指针</p>
      <p><i class="el-icon-s-opportunity"></i>类型：属于对象，而非变量</p>
      <p><i class="el-icon-s-opportunity"></i>不可变对象：一旦创建就不可修改的对象，包括字符串、元组、数值类型</p>
      <p>（该对象所指向的内存中的值不能被改变。当改变某个变量时候，由于其所指的值不能被改变，相当于把原来的值复制一份后再改变，这会开辟一个新的地址，变量再指向这个新的地址。）</p>
      <p><i class="el-icon-s-opportunity"></i>可变对象：可以修改的对象，包括列表、字典、集合
      <p>（该对象所指向的内存中的值可以被改变。变量（准确的说是引用）改变后，实际上是其所指的值直接发生改变，并没有发生复制行为，也没有开辟新的地址，通俗点说就是原地改变。）</p>
      <p></p>
      <p></p>
      <p>当我们写：</p>
      <p>a = 'python'</p>
      <p>Python解释器干的事情：</p>
      <p>1. 创建变量a</p>
      <p>2. 创建一个对象(分配一块内存)，来存储值 'python'</p>
      <p>3. 将变量与对象，通过指针连接起来，从变量到对象的连接称之为引用(变量引用对象)</p>

    </div>
    <div style="text-align: left; line-height: 20px;">
      <p style="font-weight: bold">1.赋值: 只是复制了新对象的引用，不会开辟新的内存空间</p>
      <p></p>
      <p>并不会产生一个独立的对象单独存在，只是将原有的数据块打上一个新标签，所以当其中一个标签被改变的时候，数据块就会发生变化，另一个标签也会随之改变。</p>
      <p></p>
      <p style="font-weight: bold">2.浅拷贝: 创建新对象，其内容是原对象的引用。</p>
      <p>浅拷贝有三种形式： 切片操作，工厂函数，copy模块中的copy函数。</p>
      <p>如： lst = [1,2,[3,4]]</p>
      <p>切片操作：lst1 = lst[:] 或者 lst1 = [each for each in lst]</p>
      <p>工厂函数：lst1 = list(lst)</p>
      <p>copy函数：lst1 = copy.copy(lst)</p>
      <p>浅拷贝之所以称为浅拷贝，是它仅仅只拷贝了一层，拷贝了最外围的对象本身，内部的元素都只是拷贝了一个引用而已，在lst中有一个嵌套的list[3,4]，如果我们修改了它，情况就不一样了。</p>
      <p>浅复制要分两种情况进行讨论：</p>
      <p>1）当浅复制的值是不可变对象（字符串、元组、数值类型）时和“赋值”的情况一样，对象的id值（id()函数用于获取对象的内存地址）与浅复制原来的值相同。</p>
      <p>2）当浅复制的值是可变对象（列表、字典、集合）时会产生一个“不是那么独立的对象”存在。有两种情况：</p>
      <p>第一种情况：复制的对象中无复杂子对象，原来值的改变并不会影响浅复制的值，同时浅复制的值改变也并不会影响原来的值。原来值的id值与浅复制原来的值不同。</p>
      <p>第二种情况：复制的对象中有复杂子对象（例如列表中的一个子元素是一个列表），如果不改变其中复杂子对象，浅复制的值改变并不会影响原来的值。 但是改变原来的值中的复杂子对象的值会影响浅复制的值。</p>
      <p></p>
      <p style="font-weight: bold">3.深拷贝：和浅拷贝对应，深拷贝拷贝了对象的所有元素，包括多层嵌套的元素。深拷贝出来的对象是一个全新的对象，不再与原来的对象有任何关联。</p>
      <p></p>
      <p>所以改变原有被复制对象不会对已经复制出来的新对象产生影响。</p>
      <p>只有一种形式，copy模块中的deepcopy函数</p>
      <p style="font-weight: bold">对于不可变对象的深浅拷贝</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: 20px">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step}}
              </span>步</span>
              <el-button size="mini" @click="nextStep" v-if="step >= 0 && step < 19">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step > 1">=====赋值=====</div>
            <div v-if="step > 3">(1, 2, 3)</div>
            <div v-if="step > 4">(1, 2, 3)</div>
            <div v-if="step > 5">43481128</div>
            <div v-if="step > 6">43481128</div>
            <div v-if="step > 7">=====浅拷贝=====</div>
            <div v-if="step > 9">(1, 2, 3)</div>
            <div v-if="step > 10">(1, 2, 3)</div>
            <div v-if="step > 11">43481128</div>
            <div v-if="step > 12">43481128</div>
            <div v-if="step > 13">=====深拷贝=====</div>
            <div v-if="step > 15">(1, 2, 3)</div>
            <div v-if="step > 16">(1, 2, 3)</div>
            <div v-if="step > 17">43481128</div>
            <div v-if="step > 18">43481128</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center; color: white">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center; font-size: 15px"
                        id="target1">
                        <span v-if="step > 2"> b -> (43481128)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target2">
                        <span v-if="step > 0">a -> (43481128)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center; color: white">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: 180px; height: 100px;  margin-left: 5px; color: white;" v-if="step >= 1"
                         id="targetAim">
                      <div>分配内存空间</div>
                      <div style="background-color: #dd6161; line-height: 50px; text-align: center">
                        (1, 2, 3) </br>(地址：43481128)
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>不可变对象类型，没有被拷贝的说法，即便是用深拷贝，查看id的话也是一样的，如果对其重新赋值，也只是新创建一个对象，替换掉旧的而已。</p>
      <p> 一句话就是，不可变类型，不管是深拷贝还是浅拷贝，地址值和拷贝后的值都是一样的。</p>
    </div>

    <div style="text-align: left; line-height: 25px">
      <p style="font-weight: bold">
        对于可变对象深浅拷贝
      </p>

      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode1" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step1}}
              </span>步</span>
              <el-button size="mini" @click="nextStep1" v-if="step1 >= 0 && step1 < 19">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep1">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step1 > 1">=====赋值=====</div>
            <div v-if="step1 > 3">[1, 2, 3]</div>
            <div v-if="step1 > 4">[1, 2, 3]</div>
            <div v-if="step1 > 5">37235144</div>
            <div v-if="step1 > 6">37235144</div>
            <div v-if="step1 > 7">=====浅拷贝=====</div>
            <div v-if="step1 > 9">[1, 2, 3]</div>
            <div v-if="step1 > 10">[1, 2, 3]</div>
            <div v-if="step1 > 11">37235144</div>
            <div v-if="step1 > 12">37191432</div>
            <div v-if="step1 > 13">=====深拷贝=====</div>
            <div v-if="step1 > 15">[1, 2, 3]</div>
            <div v-if="step1 > 16">[1, 2, 3]</div>
            <div v-if="step1 > 17">37235144</div>
            <div v-if="step1 > 18">37235144</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px; ">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target11">
                        <span v-if="step1 >= 9 && step1 < 15">b -> (37191432)</span>
                        <span v-if="step1 >= 15">b -> (37210184)</span>
                        <span v-if="step1 >= 3 && step1 < 9">b -> (37210184)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target21">
                        <span v-if="step1 >= 1">a -> (37235144)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: max-content; height: 100px;  margin-left: 5px; color: white;" v-if="step1 >= 1"
                        >
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " >
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; color: white" id="targetAim1">1</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >2</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >3</div>
                        <span>(37235144)</span>
                      </div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; margin-top: 20px" v-if="step1 >= 9 && step1 < 15">
                        <div style="width: 50px; height: 50px; border: 1px solid #f49c8c; color: white" id="targetAim11">1</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f49c8c; " >2</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f49c8c; " >3</div>
                        <span v-if="step1 >= 9 && step1 < 15">(37191432)</span>
                        <span v-if="step1 >= 15">(37210184)</span>
                      </div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; margin-top: 50px" v-if="step1 >= 15">
                        <div style="width: 50px; height: 50px; border: 1px solid #f49c8c; color: white" id="targetAim12">1</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f49c8c; " >2</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f49c8c; " >3</div>
                        <span v-if="step1 >= 15">(37210184)</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>赋值： 值相等，地址相等</p>
      <p>copy浅拷贝：值相等，地址不相等</p>
      <p>deepcopy深拷贝：值相等，地址不相等</p>
    </div>

    <div style="text-align: left; line-height: 25px">
      <p style="font-weight: bold">
        对于可变对象深浅拷贝(外层改变元素)
      </p>

      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode2" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step2}}
              </span>步</span>
              <el-button size="mini" @click="nextstep2" v-if="step2 >= 0 && step2 < 9">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startstep2">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step2 > 5">[1, 2, 3, [4, 5], 6]</div>
            <div v-if="step2 > 6">[1, 2, 3, [4, 5], 6]</div>
            <div v-if="step2 > 7">[1, 2, 3, [4, 5]]</div>
            <div v-if="step2 > 8">[1, 2, 3, [4, 5]]</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div  style="width: 200px; height: 50px; border: 1px solid #4c88ff;line-height: 50px; text-align: center" id="target214" >
                        <span v-if="step2 > 3">l3 -> (48898499)</span>
                      </div>
                      <div  style="width: 200px; height: 50px; border: 1px solid #4c88ff;line-height: 50px; text-align: center" id="target213" >
                        <span v-if="step2 > 2">l2 -> (15686215)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target211">
                        <span v-if="step2 > 1">l1 -> (94832830)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target222">
                        <span v-if="step2 >= 1">l -> (94832830)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: max-content; height: max-content;  margin-left: 5px; color: white;" v-if="step2 >= 1"
                         >
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " v-if="step2 >= 1" >
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; color: white" id="targetAim13">1</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >2</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >3</div>
                        <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" >
                          <div style="width: 50px; height: 50px; border: 1px solid #0000f4">引</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">4</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                        </div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " v-if="step2 >= 5">6</div>
                        <span>(94832830)</span>
                      </div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " v-if="step2 >= 3" >
                        <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; color: white" id="targetAim131">1</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; " >2</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; " >3</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; " >引</div>
                        <span>(15686215)</span>
                      </div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; margin-top: 30px" v-if="step2 >= 4" >
                        <div style="width: 50px; height: 50px; border: 1px solid #f43637; color: white" id="targetAim14">1</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f43637; " >2</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f43637; " >3</div>
                        <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" >
                          <div style="width: 50px; height: 50px; border: 1px solid #f43637">引</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">4</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                        </div>
                        <span>(48898499)</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>1.外层添加元素时，浅拷贝不会随原列表变化而变化；内层添加元素时，浅拷贝才会变化。</p>
      <p>2.无论原列表如何变化，深拷贝都保持不变。</p>
      <p>3.赋值对象随着原列表一起变化。</p>

    </div>
    <div style="text-align: left; line-height: 25px">
      <p style="font-weight: bold">
        对于可变对象深浅拷贝(内层改变元素)
      </p>

      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode3" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step3}}
              </span>步</span>
              <el-button size="mini" @click="nextstep3" v-if="step3 >= 0 && step3 < 9">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startstep3">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step3 > 5">[1, 2, 3, [4, 5, 6]]</div>
            <div v-if="step3 > 6">[1, 2, 3, [4, 5, 6]]</div>
            <div v-if="step3 > 7">[1, 2, 3, [4, 5, 6]]</div>
            <div v-if="step3 > 8">[1, 2, 3, [4, 5]]</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center" id="target443">
                        <span v-if="step3 > 3">l3 -> (12354897)</span>
                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center" id="target444">
                        <span v-if="step3 > 2">l2 -> (89654258)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target441">
                        <span v-if="step3 > 1">l1 -> (30448320)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target442">
                        <span v-if="step3 >= 1">l -> (30448320)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="display: flex; justify-content: center">
                      <div style="width: max-content; height: max-content;  margin-left: 5px; color: white;" v-if="step3 >= 1"
                      >
                        <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " v-if="step3 >= 1" >
                          <div style="width: 50px; height: 50px; border: 1px solid #0000f4; color: white" id="targetAim144">1</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >2</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >3</div>
                          <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" >
                            <div style="width: 50px; height: 50px; border: 1px solid #0000f4">引</div>
                            <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">4</div>
                            <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                            <div style="width: 50px; height: 50px; border: 1px solid #f5dab1" v-if="step3 >= 5">6</div>
                          </div>
                          <!--<div style="width: 50px; height: 50px; border: 1px solid #0000f4; " v-if="step3 >= 5">6</div>-->
                          <span>(94832830)</span>
                        </div>
                        <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " v-if="step3 >= 3" >
                          <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; color: white" id="targetAim141">1</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; " >2</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; " >3</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #5ae2f4; " >引</div>
                          <span>(89654258)</span>
                        </div>
                        <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; margin-top: 30px" v-if="step3 >= 4" >
                          <div style="width: 50px; height: 50px; border: 1px solid #f43637; color: white" id="targetAim145">1</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f43637; " >2</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f43637; " >3</div>
                          <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" >
                            <div style="width: 50px; height: 50px; border: 1px solid #f43637">引</div>
                            <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">4</div>
                            <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                          </div>
                          <span>(12354897)</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>1.外层添加元素时，浅拷贝不会随原列表变化而变化；内层添加元素时，浅拷贝才会变化。</p>
      <p>2.无论原列表如何变化，深拷贝都保持不变。</p>
      <p>3.赋值对象随着原列表一起变化。</p>

    </div>
  </div>


</template>

<script>
  import {
    qryPaperList,
    uploadImgUrl,
    uploadPdfUrl,
    qryPaperTypeList,
    updatePaperInfo,
    delPaperInfo,
    authToken
  } from '../../request/api';
  import LeaderLine from 'leader-line-vue';

  export default {
    data() {
      return {
        step: 0,
        step1: 0,
        step2: 0,
        step3: 0,
        zhichuandi: true,
        zcdCode: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "import copy", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "a=(1,2,3)", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "print(\"=====赋值=====\")", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "b=a", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "print(b)", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "print(id(a))", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "print(id(b))", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "print(\"=====浅拷贝=====\")", a: "?", b: "?", fk: false, nk: false},
          {id: 14, ml: 0, con: "b=copy.copy(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 15, ml: 0, con: "print(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 16, ml: 0, con: "print(b)", a: "?", b: "?", fk: false, nk: false},
          {id: 17, ml: 0, con: "print(id(a))", a: "?", b: "?", fk: false, nk: false},
          {id: 18, ml: 0, con: "print(id(b))", a: "?", b: "?", fk: false, nk: false},
          {id: 19, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 20, ml: 0, con: "print(\"=====深拷贝=====\")", a: "?", b: "?", fk: false, nk: false},
          {id: 21, ml: 0, con: "b=copy.deepcopy(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 22, ml: 0, con: "print(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 23, ml: 0, con: "print(b)", a: "?", b: "?", fk: false, nk: false},
          {id: 24, ml: 0, con: "print(id(a))", a: "?", b: "?", fk: false, nk: false},
          {id: 25, ml: 0, con: "print(id(b))", a: "?", b: "?", fk: false, nk: false},
        ],
        zcdCode1: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "import copy", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "a=[1,2,3]", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "print(\"=====赋值=====\")", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "b=a", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "print(b)", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "print(id(a))", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "print(id(b))", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "print(\"=====浅拷贝=====\")", a: "?", b: "?", fk: false, nk: false},
          {id: 14, ml: 0, con: "b=copy.copy(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 15, ml: 0, con: "print(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 16, ml: 0, con: "print(b)", a: "?", b: "?", fk: false, nk: false},
          {id: 17, ml: 0, con: "print(id(a))", a: "?", b: "?", fk: false, nk: false},
          {id: 18, ml: 0, con: "print(id(b))", a: "?", b: "?", fk: false, nk: false},
          {id: 19, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 20, ml: 0, con: "print(\"=====深拷贝=====\")", a: "?", b: "?", fk: false, nk: false},
          {id: 21, ml: 0, con: "b=copy.deepcopy(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 22, ml: 0, con: "print(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 23, ml: 0, con: "print(b)", a: "?", b: "?", fk: false, nk: false},
          {id: 24, ml: 0, con: "print(id(a))", a: "?", b: "?", fk: false, nk: false},
          {id: 25, ml: 0, con: "print(id(b))", a: "?", b: "?", fk: false, nk: false},
        ],
        zcdCode2: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "import copy", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "l=[1,2,3,[4, 5]]", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "l1=l #赋值", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "l2=copy.copy(l) #浅拷贝", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "l3=copy.deepcopy(l) #深拷贝", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "l.append(6)", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "print(l)", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "print(l1)", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "print(l2)", a: "?", b: "?", fk: false, nk: false},
          {id: 14, ml: 0, con: "print(l3)", a: "?", b: "?", fk: false, nk: false},
        ],
        zcdCode3: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "import copy", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "l=[1,2,3,[4, 5]]", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "l1=l #赋值", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "l2=copy.copy(l) #浅拷贝", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "l3=copy.deepcopy(l) #深拷贝", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "l[3].append(6) ", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "print(l)", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "print(l1)", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "print(l2)", a: "?", b: "?", fk: false, nk: false},
          {id: 14, ml: 0, con: "print(l3)", a: "?", b: "?", fk: false, nk: false},
        ],
        zcd: {
          main: {
            a: '?',
            b: '?',
          },
          swap: {
            a: '?',
            b: '?',
            t: '?',
          },
          swapShow: false,
        },
        answerVisible: false,
        answerInfoVisible: false,
        answerInfoSuccessVisible: false,
        zcdAnswer: {
          a: '',
          b: ''
        },
        showStep: true,
        nowScore: 0,
        close: false,
        xLeaderLine: null,
        yLeaderLine: null,
        xLeaderLine1: null,
        xLeaderLine2: null,
        xLeaderLine3: null,
        xLeaderLine4: null,
        xLeaderLine5: null,
        xLeaderLine6: null,
        xLeaderLine7: null,
        xLeaderLine8: null,
        xLeaderLine9: null,
        xLeaderLine10: null,
        xLeaderLine11: null,
        xLeaderLine12: null,

      };
    },
    methods: {
      handleScroll() {
        console.log("滚动了")
        if (this.xLeaderLine != null) {
          this.xLeaderLine.position();
        }
        if (this.yLeaderLine != null) {
          this.yLeaderLine.position();
        }
        if (this.xLeaderLine1 != null) {
          this.xLeaderLine1.position();
        }
        if (this.xLeaderLine2 != null) {
          this.xLeaderLine2.position();
        }
        if (this.xLeaderLine3 != null) {
          this.xLeaderLine3.position();
        }
        if (this.xLeaderLine4 != null) {
          this.xLeaderLine4.position();
        }
        if (this.xLeaderLine5 != null) {
          this.xLeaderLine5.position();
        }
        if (this.xLeaderLine6 != null) {
          this.xLeaderLine6.position();
        }
        if (this.xLeaderLine7 != null) {
          this.xLeaderLine7.position();
        }
        if (this.xLeaderLine8 != null) {
          this.xLeaderLine8.position();
        }
        if (this.xLeaderLine9 != null) {
          this.xLeaderLine9.position();
        }
        if (this.xLeaderLine10 != null) {
          this.xLeaderLine10.position();
        }
        if (this.xLeaderLine11 != null) {
          this.xLeaderLine11.position();
        }
        if (this.xLeaderLine12 != null) {
          this.xLeaderLine12.position();
        }

      },
      startStep() {
        this.step = 0;
        this.zcdStepCon();
        if (this.xLeaderLine != null) {
          this.xLeaderLine.remove();
          this.xLeaderLine = null
        }
        if (this.yLeaderLine != null) {
          this.yLeaderLine.remove();
          this.yLeaderLine = null
        }
      },
      nextStep() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step++;
          this.zcdStepCon();
        }
      },
      zcdStepCon() {
        // 第二步
        this.zcdCode.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step === 1) {
          this.zcdCode[4].fk = true;
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim');
            const target2 = document.querySelector('#target2');
            this.xLeaderLine = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step === 2) {
          this.zcdCode[5].fk = true;
        } else if (this.step === 3) {
          this.zcdCode[6].fk = true;
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim');
            const target1 = document.querySelector('#target1');
            this.yLeaderLine = LeaderLine.setLine(target1, targetAim);
          });
        } else if (this.step === 4) {
          this.zcdCode[7].fk = true;
        } else if (this.step === 5) {
          this.zcdCode[8].fk = true;
        } else if (this.step === 6) {
          this.zcdCode[9].fk = true;
        } else if (this.step === 7) {
          this.zcdCode[10].fk = true;
        } else if (this.step === 8) {
          this.zcdCode[12].fk = true;
        } else if (this.step === 9) {
          this.zcdCode[13].fk = true;
        } else if (this.step === 10) {
          this.zcdCode[14].fk = true;
        } else if (this.step === 11) {
          this.zcdCode[15].fk = true;
        } else if (this.step === 12) {
          this.zcdCode[16].fk = true;
        } else if (this.step === 13) {
          this.zcdCode[17].fk = true;
        } else if (this.step === 14) {
          this.zcdCode[19].fk = true;
        } else if (this.step === 15) {
          this.zcdCode[20].fk = true;
        } else if (this.step === 16) {
          this.zcdCode[21].fk = true;
        } else if (this.step === 17) {
          this.zcdCode[22].fk = true;
        } else if (this.step === 18) {
          this.zcdCode[23].fk = true;
        } else if (this.step === 19) {
          this.zcdCode[24].fk = true;
        }

      },
      startStep1() {
        this.step1 = 0;
        this.zcdstep1Con1();
        if (this.xLeaderLine1 != null) {
          this.xLeaderLine1.remove();
          this.xLeaderLine1 = null
        }
        if (this.xLeaderLine2 != null) {
          this.xLeaderLine2.remove();
          this.xLeaderLine2 = null
        }
        if (this.xLeaderLine3 != null) {
          this.xLeaderLine3.remove();
          this.xLeaderLine3 = null
        }
        if (this.xLeaderLine4 != null) {
          this.xLeaderLine4.remove();
          this.xLeaderLine4 = null
        }

      },
      nextStep1() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step1++;
          this.zcdstep1Con1();
        }
      },
      zcdstep1Con1() {
        // 第二步
        this.zcdCode1.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step1 === 1) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim1');
            const target2 = document.querySelector('#target21');
            this.xLeaderLine1 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode1[4].fk = true;
        } else if (this.step1 === 2) {
          this.zcdCode1[5].fk = true;
        } else if (this.step1 === 3) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim1');
            const target2 = document.querySelector('#target11');
            this.xLeaderLine2 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode1[6].fk = true;
        } else if (this.step1 === 4) {
          this.zcdCode1[7].fk = true;
        } else if (this.step1 === 5) {
          this.zcdCode1[8].fk = true;
        } else if (this.step1 === 6) {
          this.zcdCode1[9].fk = true;
        } else if (this.step1 === 7) {
          this.zcdCode1[10].fk = true;
        } else if (this.step1 === 8) {
          this.zcdCode1[12].fk = true;
        } else if (this.step1 === 9) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim11');
            const target2 = document.querySelector('#target11');
            this.xLeaderLine2.hide()
            this.xLeaderLine3 = LeaderLine.setLine(target2, targetAim);
          });


          this.zcdCode1[13].fk = true;
        } else if (this.step1 === 10) {
          this.zcdCode1[14].fk = true;
        } else if (this.step1 === 11) {
          this.zcdCode1[15].fk = true;
        }else if (this.step1 === 12) {
          this.zcdCode1[16].fk = true;
        }else if (this.step1 === 13) {
          this.zcdCode1[17].fk = true;
        }else if (this.step1 === 14) {
          this.zcdCode1[19].fk = true;
        }else if (this.step1 === 15) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim12');
            const target2 = document.querySelector('#target11');
            this.xLeaderLine3.hide()
            this.xLeaderLine4 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode1[20].fk = true;
        }else if (this.step1 === 16) {
          this.zcdCode1[21].fk = true;
        }else if (this.step1 === 17) {
          this.zcdCode1[22].fk = true;
        }else if (this.step1 === 18) {
          this.zcdCode1[23].fk = true;
        }else if (this.step1 === 19) {
          this.zcdCode1[24].fk = true;
        }
      },
      startstep2() {
        this.step2 = 0;
        this.zcdstep2Con2();
        if (this.xLeaderLine5 != null) {
          this.xLeaderLine5.remove();
          this.xLeaderLine5 = null
        }
        if (this.xLeaderLine6 != null) {
          this.xLeaderLine6.remove();
          this.xLeaderLine6 = null
        }
        if (this.xLeaderLine7 != null) {
          this.xLeaderLine7.remove();
          this.xLeaderLine7 = null
        }
        if (this.xLeaderLine8 != null) {
          this.xLeaderLine8.remove();
          this.xLeaderLine8 = null
        }

      },
      nextstep2() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step2++;
          this.zcdstep2Con2();
        }
      },
      zcdstep2Con2() {
        // 第二步
        this.zcdCode2.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step2 === 1) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim13');
            const target2 = document.querySelector('#target222');
            this.xLeaderLine8 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode2[4].fk = true;
        } else if (this.step2 === 2) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim13');
            const target2 = document.querySelector('#target211');
            this.xLeaderLine5 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode2[5].fk = true;
        } else if (this.step2 === 3) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim131');
            const target2 = document.querySelector('#target213');
            this.xLeaderLine6 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode2[6].fk = true;
        } else if (this.step2 === 4) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim14');
            const target2 = document.querySelector('#target214');
            this.xLeaderLine7 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode2[7].fk = true;
        } else if (this.step2 === 5) {
          this.$nextTick(() => {
            this.xLeaderLine7.position()
            this.xLeaderLine6.position()
            this.xLeaderLine5.position()
            this.xLeaderLine8.position()
          })
          this.zcdCode2[8].fk = true;
        } else if (this.step2 === 6) {
          this.zcdCode2[10].fk = true;
        } else if (this.step2 === 7) {
          this.zcdCode2[11].fk = true;
        } else if (this.step2 === 8) {
          this.zcdCode2[12].fk = true;
        } else if (this.step2 === 9) {
          this.zcdCode2[13].fk = true;
        }

      },
      startstep3() {
        this.step3 = 0;
        this.zcdstep3Con2();
        if (this.xLeaderLine9 != null) {
          this.xLeaderLine9.remove();
          this.xLeaderLine9 = null
        }
        if (this.xLeaderLine10 != null) {
          this.xLeaderLine10.remove();
          this.xLeaderLine10 = null
        }

        if (this.xLeaderLine11 != null) {
          this.xLeaderLine11.remove();
          this.xLeaderLine11 = null
        }

        if (this.xLeaderLine12 != null) {
          this.xLeaderLine12.remove();
          this.xLeaderLine12 = null
        }


      },
      nextstep3() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step3++;
          this.zcdstep3Con2();
        }
      },
      zcdstep3Con2() {
        // 第二步
        this.zcdCode3.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step3 === 1) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim144');
            const target2 = document.querySelector('#target442');
            this.xLeaderLine9 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode3[4].fk = true;
        } else if (this.step3 === 2) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim144');
            const target2 = document.querySelector('#target441');
            this.xLeaderLine10 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode3[5].fk = true;
        } else if (this.step3 === 3) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim141');
            const target2 = document.querySelector('#target444');
            this.xLeaderLine11 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode3[6].fk = true;
        } else if (this.step3 === 4) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim145');
            const target2 = document.querySelector('#target443');
            this.xLeaderLine12 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode3[7].fk = true;
        } else if (this.step3 === 5) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            this.xLeaderLine11.position();
            this.xLeaderLine12.position();
          });
          this.zcdCode3[8].fk = true;
        } else if (this.step3 === 6) {

          this.zcdCode3[10].fk = true;
        } else if (this.step3 === 7) {
          this.zcdCode3[11].fk = true;
        } else if (this.step3 === 8) {
          this.zcdCode3[12].fk = true;
        } else if (this.step3 === 9) {
          this.zcdCode3[13].fk = true;
        } else if (this.step3 === 10) {
          this.zcdCode3[14].fk = true;
        }

      },

    },

    beforeDestroy() {
      if (this.xLeaderLine != null) {
        this.xLeaderLine.remove();
        this.xLeaderLine = null
      }
      if (this.yLeaderLine != null) {
        this.yLeaderLine.remove();
        this.yLeaderLine = null
      }
      if (this.xLeaderLine1 != null) {
        this.xLeaderLine1.remove();
        this.xLeaderLine1 = null
      }
      if (this.xLeaderLine2 != null) {
        this.xLeaderLine2.remove();
        this.xLeaderLine2 = null
      }
      if (this.xLeaderLine3 != null) {
        this.xLeaderLine3.remove();
        this.xLeaderLine3 = null
      }
      if (this.xLeaderLine4 != null) {
        this.xLeaderLine4.remove();
        this.xLeaderLine4 = null
      }
      if (this.xLeaderLine5 != null) {
        this.xLeaderLine5.remove();
        this.xLeaderLine5 = null
      }
      if (this.xLeaderLine6 != null) {
        this.xLeaderLine6.remove();
        this.xLeaderLine6 = null
      }
      if (this.xLeaderLine7 != null) {
        this.xLeaderLine7.remove();
        this.xLeaderLine7 = null
      }

      if (this.xLeaderLine8 != null) {
        this.xLeaderLine8.remove();
        this.xLeaderLine8 = null
      }
      if (this.xLeaderLine9 != null) {
        this.xLeaderLine9.remove();
        this.xLeaderLine9 = null
      }
      if (this.xLeaderLine10 != null) {
        this.xLeaderLine10.remove();
        this.xLeaderLine10 = null
      }
      if (this.xLeaderLine11 != null) {
        this.xLeaderLine11.remove();
        this.xLeaderLine11 = null
      }
      if (this.xLeaderLine12 != null) {
        this.xLeaderLine12.remove();
        this.xLeaderLine12 = null
      }
    },
    destroyed() {

    },
    mounted() {

    },
    props: ["itemData"]
  };
</script>

<style lang="less">
  .lwgl {
    background-color: #EFF3FF;
    padding: 20px;
    height: calc(100vh - 216px);
    overflow-y: auto;
    line-height: 27px;
    font-size: 16px;
  }

  .el-table th.el-table__cell {
    background-color: #EFF3FF;
  }

  .searchClass {
    width: 900px;
    height: 70px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
  }

  .upload-demo {
    text-align: left;
  }

  .lwgl .el-table .el-table__body-wrapper {
    height: calc(100vh - 455px);
    min-height: 250px;
    overflow-y: auto;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .searchClass .el-form--inline .el-form-item__content {
    margin-top: 13px;
  }

  p {
    text-indent: 2em;
  }


</style>




// WEBPACK FOOTER //
// src/components/lw/lwgl03.vue